var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7247 10.6673V12.534C10.7247 13.2807 10.7247 13.6541 10.5786 13.9393C10.45 14.1902 10.2449 14.3942 9.99267 14.522C9.70588 14.6673 9.33045 14.6673 8.57959 14.6673H3.48495C2.73409 14.6673 2.35867 14.6673 2.07188 14.522C1.81961 14.3942 1.61451 14.1902 1.48597 13.9393C1.33984 13.6541 1.33984 13.2807 1.33984 12.534V7.46732C1.33984 6.72058 1.33984 6.34721 1.48597 6.062C1.61451 5.81111 1.81961 5.60714 2.07188 5.47931C2.35867 5.33398 2.73409 5.33398 3.48495 5.33398H5.36193M7.50704 10.6673H12.6017C13.3525 10.6673 13.728 10.6673 14.0148 10.522C14.267 10.3942 14.4721 10.1902 14.6007 9.93931C14.7468 9.65409 14.7468 9.28072 14.7468 8.53398V3.46732C14.7468 2.72058 14.7468 2.34721 14.6007 2.062C14.4721 1.81111 14.267 1.60714 14.0148 1.47931C13.728 1.33398 13.3525 1.33398 12.6017 1.33398H7.50704C6.75618 1.33398 6.38075 1.33398 6.09396 1.47931C5.84169 1.60714 5.63659 1.81111 5.50805 2.062C5.36193 2.34721 5.36193 2.72058 5.36193 3.46732V8.53398C5.36193 9.28072 5.36193 9.65409 5.50805 9.93931C5.63659 10.1902 5.84169 10.3942 6.09396 10.522C6.38075 10.6673 6.75618 10.6673 7.50704 10.6673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLogo);
export default __webpack_public_path__ + "static/media/Copy-logo.7e63a6ba676aa6ded2d2d6b90b49617f.svg";
export { ForwardRef as ReactComponent };